var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-menu__item",
      class: [
        { "m-menu__item--active": _vm.active },
        { "m-menu__item--parent": _vm.parent }
      ],
      attrs: { "aria-haspopup": "true" }
    },
    [
      _c(
        "router-link",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.name !== "cargo_vehicular" ||
                (_vm.name === "cargo_vehicular" &&
                  _vm.features.cargo_property === "true"),
              expression:
                "(name !== 'cargo_vehicular') || (name === 'cargo_vehicular' && features.cargo_property === 'true')"
            }
          ],
          staticClass: "m-menu__link",
          attrs: { to: _vm.validateRoute(_vm.name, _vm.link) }
        },
        [
          !_vm.parent
            ? _c(
                "i",
                { staticClass: "m-menu__link-bullet m-menu__link-bullet--dot" },
                [_c("span")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "m-menu__link-text" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("titleize")(
                    _vm._f("translate")(_vm.validateName(_vm.name, _vm.link))
                  )
                ) +
                "\n    "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56042baf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56042baf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/sidebar/Submenu.vue
// module id = 571
// module chunks = 0 54 76 153